/*
 * 网站配置相关
 * author: kirkzheng
 * time: 2016-06-17
 */
const isProduction = process.env.DEPLOY_ENV === 'production';

// 网站路径相关
export const SITE = {
  parentDomain: 'qq.com', // 顶级域名
  domain: document.domain, // app域名
  smbUrl: '/agp/', // 服务商融合后新的接口地址
  serverPhone: '400-900-5050', // 客服电话
  portalUrl: '//e.qq.com/index.shtml', // 官网首页
  ssoUrl: 'https://sso.e.qq.com/login/portal',
  adpUrl: `${location.origin}/adp/advertiser/`,
  cpsUrl: `${location.origin}/contentad/`,
  enterpriseAPI: '//midas.gtimg.cn/enterprise/js/enterpriseAPI_v1.0.1.js', //
  html2pdf: 'https://public.gdtimg.com/qzone/biz/gdt/lib/html2pdf-0.9.2/html2pdf.js', // html2pdf
  skipAuthPath: [/task-advertiser/],
  huxuanUrl: isProduction ? 'https://huxuan.qq.com/' : 'https://test-huxuan.qq.com/',
};

export default { SITE };
